import React from 'react';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';

const Glossary = ({ data }) => {
  const {
    title,
    showTitle,
    images
  } = data;
  return (
    <Section>
      <Container>
        {(showTitle && title) && <h2 className='mx-auto mb-4 col-lg-10 text-center'>{title}</h2>}
        <Row className='d-flex flex-column flex-md-row'>
          {images.map((image, index) => (
            <div key={index} className='d-flex flex-row align-items-center col-md-6'>
              <div className='col-4'>
                <Img image={image.gatsbyImageData} file={image.file} />
              </div>
              <p className='fs-24'>
                <strong>{image.title}</strong>
                {' = '}{image.description}
              </p>
            </div>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default Glossary
